// eslint-disable-next-line import/no-extraneous-dependencies
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import _ from 'lodash';
// eslint-disable-next-line import/no-extraneous-dependencies
import Big from 'big.js';
import { getBogoIndividualDiscount, sortSpecials, isCumulative } from 'shared/order/utilities';
var getRewardsToApply = function(applicableBogoRewards, applyStowedDiscounts, stowedDiscounts) {
    if (!applyStowedDiscounts) {
        return _.reject(applicableBogoRewards, function(param) {
            var isSecpoDtc = param.isSecpoDtc;
            return isSecpoDtc;
        });
    }
    return _.reduce(stowedDiscounts, function(bogoDiscounts, discount) {
        if (discount.type === 'bogo') {
            bogoDiscounts.push(_object_spread_props(_object_spread({}, discount.discountData), {
                _quantityToApply: discount.quantityToApply || 0
            }));
        }
        return bogoDiscounts;
    }, []);
};
var calculateBogoDiscounts = function(param) {
    var applicableBogoRewards = param.applicableBogoRewards, applyStowedDiscounts = param.applyStowedDiscounts, _param_bogoRewardsApplied = param.bogoRewardsApplied, bogoRewardsApplied = _param_bogoRewardsApplied === void 0 ? {} : _param_bogoRewardsApplied, compositePrice = param.compositePrice, credit = param.credit, detail = param.detail, dtcIndividualPrice = param.dtcIndividualPrice, discountTaxOrder = param.discountTaxOrder, originalCompositePrice = param.originalCompositePrice, productTotal = param.productTotal, receiptDetail = param.receiptDetail, globalSpecialsSettings = param.globalSpecialsSettings, stowDiscounts = param.stowDiscounts, stowedDiscounts = param.stowedDiscounts;
    var quantity = detail.quantity;
    var rewardsToApply = getRewardsToApply(applicableBogoRewards, applyStowedDiscounts, stowedDiscounts);
    rewardsToApply = sortSpecials(rewardsToApply, {});
    if (rewardsToApply.length > 0) {
        var bogoSavings = {
            individual: [],
            total: Big(0)
        };
        _.forEach(rewardsToApply, function(bogoReward) {
            var individualPrice;
            if (dtcIndividualPrice) {
                individualPrice = dtcIndividualPrice;
            } else {
                var stackingBehaviorIsCumulative = isCumulative(bogoReward.stackingBehavior, globalSpecialsSettings.stackingBehavior);
                var startingPrice;
                var _bogoReward_discountStacking, _ref;
                var discountStackingEnabled = (_ref = (_bogoReward_discountStacking = bogoReward === null || bogoReward === void 0 ? void 0 : bogoReward.discountStacking) !== null && _bogoReward_discountStacking !== void 0 ? _bogoReward_discountStacking : globalSpecialsSettings.discountStacking) !== null && _ref !== void 0 ? _ref : false;
                startingPrice = originalCompositePrice;
                if (discountStackingEnabled && !stackingBehaviorIsCumulative) {
                    startingPrice = compositePrice;
                }
                individualPrice = startingPrice.div(detail.quantity);
            }
            var individualDiscount = getBogoIndividualDiscount(bogoReward, individualPrice);
            var applicableQuantity;
            if (bogoReward === null || bogoReward === void 0 ? void 0 : bogoReward.isDiscountToCartReward) {
                applicableQuantity = quantity;
            } else if (!_.isNil(bogoReward === null || bogoReward === void 0 ? void 0 : bogoReward._quantityToApply)) {
                applicableQuantity = bogoReward._quantityToApply;
            } else {
                applicableQuantity = (bogoReward === null || bogoReward === void 0 ? void 0 : bogoReward.applicableQuantity) || 0;
            }
            var additionalCredit = individualDiscount.times(applicableQuantity);
            if (stowDiscounts) {
                stowedDiscounts.push({
                    applicableQuantity: applicableQuantity,
                    conditionQuantity: (bogoReward === null || bogoReward === void 0 ? void 0 : bogoReward.conditionQuantity) || 0,
                    discountData: bogoReward,
                    individualDiscount: individualDiscount,
                    key: "".concat(bogoReward.specialId, "_").concat(bogoReward.rewardId),
                    type: "bogo"
                });
            } else {
                bogoRewardsApplied["rid_".concat(bogoReward.rewardId)] = (bogoRewardsApplied["rid_".concat(bogoReward.rewardId)] || 0) + applicableQuantity;
                bogoRewardsApplied["sid_".concat(bogoReward.specialId)] = (bogoRewardsApplied["sid_".concat(bogoReward.specialId)] || 0) + applicableQuantity;
                bogoSavings.individual.push(_object_spread_props(_object_spread({
                    conditionQuantity: (bogoReward === null || bogoReward === void 0 ? void 0 : bogoReward.conditionQuantity) || 0,
                    discountAmount: individualDiscount
                }, (bogoReward === null || bogoReward === void 0 ? void 0 : bogoReward.dollarDiscount) ? {
                    dollarDiscount: bogoReward.dollarDiscount || 0
                } : {}, (bogoReward === null || bogoReward === void 0 ? void 0 : bogoReward.percentDiscount) ? {
                    percentDiscount: bogoReward.percentDiscount || 0
                } : {}, (bogoReward === null || bogoReward === void 0 ? void 0 : bogoReward.targetPrice) ? {
                    targetPrice: bogoReward.targetPrice || 0
                } : {}), {
                    isDiscountToCartReward: bogoReward === null || bogoReward === void 0 ? void 0 : bogoReward.isDiscountToCartReward,
                    displayAsPercentDiscount: bogoReward === null || bogoReward === void 0 ? void 0 : bogoReward.displayAsPercentDiscount,
                    maxApplicable: applicableQuantity,
                    specialId: bogoReward.specialId,
                    stackingBehavior: bogoReward.stackingBehavior,
                    nonStackingBehavior: bogoReward.nonStackingBehavior,
                    discountStacking: bogoReward.discountStacking
                }));
                bogoSavings.total = bogoSavings.total.add(additionalCredit);
                compositePrice = compositePrice.minus(additionalCredit);
                // Depending on tax config, add the credit into the total. This is to make the subtotal on the checkout ticket
                // look more like the menu.
                if (discountTaxOrder === 'taxesFirst' || Big(detail.basePriceMult, "Base Price Mult").eq(1)) {
                    credit = credit.plus(additionalCredit);
                } else {
                    productTotal = productTotal.minus(additionalCredit);
                }
                var specialSettings = {
                    discountStacking: bogoReward.discountStacking,
                    discountPrecedence: bogoReward.discountPrecedence,
                    stackingBehavior: bogoReward.stackingBehavior,
                    settingsDerivedFrom: bogoReward.settingsDerivedFrom
                };
                if (receiptDetail && additionalCredit.gt(0)) {
                    receiptDetail.addDiscount({
                        type: "bogo",
                        value: additionalCredit.times(100),
                        id: bogoReward.specialId,
                        name: bogoReward.specialName,
                        additionalAttributes: {
                            satisfiedBy: _.values(bogoReward.satisfiedBy),
                            specialSettings: specialSettings
                        }
                    });
                }
            }
        });
        if (!stowDiscounts) {
            detail.bogoSavings = bogoSavings;
        }
    }
    return {
        bogoRewardsApplied: bogoRewardsApplied,
        compositePrice: compositePrice,
        credit: credit,
        productTotal: productTotal,
        stowedDiscounts: stowedDiscounts
    };
};
export default calculateBogoDiscounts;
